/*
  Utility Actions:
  These are redux actions that do not cause store changes. They are used mainly to support
  middleware.
  Prefix and suffix with '<><><>-' '-<><><>' so they stand out in the redux log!
  Side note: I really wanted to import friendBot and have them say lovely messages in these
  actions but I was worried that emojis may break older browers or soemthing :sob:
*/


const REDUX_INIT = '<><><>-REDUX_INIT-<><><>';
const REDUX_SYNC = '<><><>-SYNC-<><><>';

// FN: 10/07/2020
// Redux calls an action type of '@@INIT' when it first loads. However it's considered bad to try
// and react to that, so we create out own:
// https://github.com/reduxjs/redux/issues/186
// Side note:
// I really wanted to call this 'reduxInitMate'
// Only fire this once!
const reduxInit = (devNote) => ({
  type: REDUX_INIT,
  payload: {
    devNote,
  },
});


// Some actions are only fired from middleware and it's the middeware's responsibility to figure out
// when to fire those actions. However the process of "figuring it out" is only triggered when actions
// are dispatched. As such, this action is a handy little action to fire whenever we need middleware
// do something clever
// Fire this as many times as you want!
const reduxSync = (devNote) => ({
  type: REDUX_SYNC,
  payload: {
    devNote,
  },
});


export {
  reduxInit,
  reduxSync,
  REDUX_INIT,
  REDUX_SYNC,
};

